export default __webpack_public_path__ + "static/media/logo.92804ae2.svg";